export const endPoints = {
  customer: {
    fetchAllCustomers: "/customer/get-customer-all-detailed-record",
  },
  leads: {
    fetchleads: "/lead/get-leads",
    upsertLead: "/lead/auth-upsert-lead",
  },
  opportunity: {
    createOpportunity: "/lead/create-opportunity",
    fetchOpportunities: "/lead/get-opportunity",
  },
  followUps: {
    fetchFollowUps: "/lead/get-followup",
    upsertFollowUp: "/lead/edit-followup",
  },
  insurer: {
    createInsurer: "/insurance/create-insurer-code",
  },
  csioCompany: {
    upsertCSIOCompany: "/insurance/create-csio-company-record",
  },
  subInusrer: {
    upsertSubInsurer: "/insurance/create-insurer-sub",
  },
  policyComission: {
    upsertPolicyComission: "/insurance/create-policy-commission",
  },
  insurerContacts: {
    upsertInsurerContacts: "/insurance/create-insurer-contacts",
  },
  underWriters: {
    upsertUnderwriters: "/insurance/create-underwriters",
  },
  brokerCodes: {
    createBrokerCode: "/insurance/create-broker-code",
  },
  brokerContacts: {
    createBorkerContact: "/insurance/create-broker-contracts",
  },
  branchOffice: {
    createBranchOffice: "/insurance/create-branch-office",
  },
  interestedParty: {
    createIntrestedParty: "/insurance/create-interested-party",
  },
  additionalIntrest: {
    createAdditionalIntrest: "/insurance/create-additional-interest",
  },
  appForms: {
    editAppForms: "/other/edit-apps-and-forms",
  },
  support: {
    upsertSupport: "/other/create-support-ticket",
  },
  legalPlus: {
    upsertLegal: "/other/upsert-legal-plus",
  },
  groupPlans: {
    upsertGroupPlan: "/insurance/upsert-broker-group-plan",
  },
  quotes: {
    upsertQuote: "/policy/edit-policy-quote-reference",
    fetchQuotes: "/policy/get-policy-quote-reference",
    addQuoteARSFile: "/general/extract-product-with-gen-ai",
  },
  comments: {
    upsertComment: "/general/upsert-comments",
  },
  customerPolicyUpdate: {
    upsert: "/policy/upsert-policy-update",
    publicUpsert: "/policy/upsert-policy-update-external",
  },
  importBulkPaymentBill: {
    fetchImportBulkPaymentBill:
      "/import-utility/get-temp-bank-statement-of-invoice-and-bill",
    fetchImportBulkBillPaymentList:
      "/import-utility/get-temporary-bank-statement-of-invoice-and-bill",
  },
  changeHistory: {
    fetchChangeHistory: "/history/get-change-history",
  },
};
